export default __webpack_public_path__ + "static/media/tobottom.60a3c225.svg";